import PropTypes from 'prop-types';
import {
  MODULE_STATUSES,
  MODULE_TYPES,
} from '../../../services/utilityFunctions';
import ImageProp from '../../../commonComponents/propTypes/imageProp';
import LessonProp from './lessonProp';
import CertificateProp from './certificateProp';

const propType = {
  _id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(MODULE_TYPES).isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.shape(ImageProp.propType),
  pos: PropTypes.number.isRequired,
  level: PropTypes.number.isRequired,
  status: PropTypes.oneOf(MODULE_STATUSES),
  lessons: PropTypes.number,
  lessonsList: PropTypes.arrayOf(PropTypes.shape(LessonProp.propType)),
  duration: PropTypes.number,
  progress: PropTypes.number,
  certificate: PropTypes.shape(CertificateProp.propType),
};

export default { propType };
